<template>
  <button class="audio-skip">
    <FowardIcon v-if="isFoward"/>
    <RewindIcon v-else />
  </button>
</template>

<script setup>
  import FowardIcon from '../../svg/FowardIcon.vue';
  import RewindIcon from '../../svg/RewindIcon.vue';
  //-------------------------------------
  const props = defineProps({
    //Напрвление перемотки
    isFoward: { type: Boolean }
  });
</script>

<style lang="scss">
  @import './styles';
</style>